export function formatHours(hours: number): string {
  const hoursRounded = Math.round(hours);
  if (hoursRounded === 0) {
    return '0 hours';
  }
  const daysRounded = Math.floor(hoursRounded / 24);
  const hoursRemainder = hoursRounded % 24;

  const daysSuffix = daysRounded === 1 ? 'day' : 'days';
  const hoursSuffix = hoursRemainder === 1 ? 'hour' : 'hours';

  return `${daysRounded > 0 ? `${daysRounded} ${daysSuffix}` : ''}${
    hoursRemainder > 0 ? ` ${hoursRemainder} ${hoursSuffix}` : ''
  }`;
}
